








































import { Component } from 'vue-property-decorator';
import { VHeaders, PaginationModel } from '@/models/pagedlistmodel';
import { DealShipment } from '@/models/filebunker/shipment';
import { Base } from '@/components/common/base';
import { getTrackingInfoHeaders } from '@/views/fileBunker/deal/deal';
import {shipmentService,attachmentService} from '@/shared';

@Component({
  props: ['methodName', 'progress'],
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
  },
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class DealTrackingInfoPage extends Base {
  public headers: VHeaders[] = getTrackingInfoHeaders(this);
  public pagedShipments: DealShipment[] = [];
  public $moment: any;
  public pagination = new PaginationModel('trackingId');
  public loading: boolean = false;

  public dealId: number;
  public actions: any[] = [];

  public mounted(): void {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'deals');
    
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    this.dealId = Number(this.$route.params.dealId);
    this.getDealShippingDetails();
    this.setAction();
  }

    public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }

  public callMethod(methodName): void {
    if (methodName === 'backToList') {
      this.backToList();
    }
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: this.$parent.$t('dealTracking.btnBackToList') as string,
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$parent.$t('dealTracking.btnBackToList') as string,
      click: 'backToList',
      icon: 'fas fa-arrow-left',
    });
    this.$emit('updateToolBar', buttons);
  }

  public setAction() {
    this.actions = [
      {
        type: 'button',
        icon: 'fas fa-eye',
        title: this.$t(
          'dealTracking.gridHeaders.gridAction.openShipmentLabel'
        ) as string,
        action: (model: DealShipment) => {
          this.openAttachment(model.attachmentId);
        },
      },
      {
        type: 'button',
        icon: 'fab fa-fedex',
        title: this.$t(
          'dealTracking.gridHeaders.gridAction.trackingInfo'
        ) as string,
        action: (model: DealShipment) => {
          this.openFedexTracking(model.trackingId);
        },
      },
    ];
  }

  public async getDealShippingDetails(): Promise<void> {
    try {
      this.loading = true;
      const dealShipments = await shipmentService.getDealShipments(
        this.dealId
      );
      this.pagedShipments = dealShipments.results;
      this.pagination.totalItems = dealShipments.total;
    } finally {
      this.loading = false;
    }
  }

  public updatePaging(paging: any) {
    this.pagination = paging;
  }

  public openFedexTracking(trackingId: any) {
    if (trackingId) {
      window.open(
        'https://www.fedex.com/apps/fedextrack/?action=track&trackingnumber=' +
          trackingId
      );
    } else {
      this.showAlert(false, this.$t('dealTracking.alertTrackingNotFound'));
    }
  }

  public openAttachment(id: any) {
    if (id) {
      attachmentService.viewAttachmentAsync(id);
    } else {
      this.showAlert(false, this.$t('dealTracking.alertShipmentNotFound'));
    }
  }

  public backToList() {
    if (history.state && history.length > 1) {
      this.$router.back();
    } else {
      this.$router.push({ name: 'app.deals' });
    }
  }
}
